import { Link, NavLink } from "react-router-dom";
import SignalField from "./SignalField";
import { companyProfile, navigationItems } from "../data/siteContent";

const SiteLayout = ({ children }) => {
  return (
    <div className="site-shell">
      <div className="site-background" aria-hidden="true">
        <div className="ambient-layer">
          <span className="ambient-smoke ambient-smoke--one" />
          <span className="ambient-smoke ambient-smoke--two" />
          <span className="ambient-smoke ambient-smoke--three" />
          <span className="ambient-glow ambient-glow--one" />
          <span className="ambient-glow ambient-glow--two" />
          <span className="ambient-noise" />
        </div>
        <SignalField />
      </div>

      <header className="site-header">
        <div className="site-container site-header__inner">
          <NavLink className="brand-link" data-testid="site-brand-link" to="/">
            <span className="brand-link__title" data-testid="site-brand-title">
              {companyProfile.name}
            </span>
            <span className="brand-link__subtitle" data-testid="site-brand-subtitle">
              {companyProfile.tagline}
            </span>
          </NavLink>

          <nav className="nav-links" data-testid="site-navigation">
            {navigationItems.map((item) => (
              <NavLink
                key={item.href}
                className={({ isActive }) => `nav-link${isActive ? " is-active" : ""}`}
                data-testid={`nav-link-${item.label.toLowerCase()}`}
                to={item.href}
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      </header>

      <main className="site-main">
        <div className="site-container">{children}</div>
      </main>

      <footer>
        <div className="site-container site-footer">
          <div data-testid="footer-company-block">
            <div className="footer-title" data-testid="footer-company-title">
              {companyProfile.name}
            </div>
            <div className="footer-subtitle" data-testid="footer-company-tagline">
              {companyProfile.tagline}
            </div>
          </div>

          <a
            className="footer-contact"
            data-testid="footer-contact-email"
            href={`mailto:${companyProfile.contactEmail}`}
          >
            {companyProfile.contactEmail}
          </a>

          <div className="footer-links" data-testid="footer-legal-links">
            <Link className="footer-link" data-testid="footer-privacy-link" to="/privacy-policy">
              Privacy Policy
            </Link>
            <Link className="footer-link" data-testid="footer-terms-link" to="/terms-of-service">
              Terms of Service
            </Link>
            <Link className="footer-link" data-testid="footer-refund-link" to="/refund-policy">
              Refund Policy
            </Link>
          </div>

          <div className="footer-meta" data-testid="footer-legal-block">
            <div data-testid="footer-legal-name">{companyProfile.legalName}</div>
            <div data-testid="footer-registered-location">
              {companyProfile.registeredLocation}
            </div>
            <div data-testid="footer-copyright">{companyProfile.footerCopy}</div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default SiteLayout;